export default __webpack_public_path__ + "static/media/dial_for_improvement.c0bd533f.svg";